export default __webpack_public_path__ + "static/media/productsCocer1.07617dba.svg";